import script from "./TagsManager.vue?vue&type=script&setup=true&lang=js"
export * from "./TagsManager.vue?vue&type=script&setup=true&lang=js"

import "./TagsManager.vue?vue&type=style&index=0&id=5b25f1f6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b25f1f6"]])

export default __exports__